<template>
  <div
    class="flex flex-col gap-2 lg:gap-3"
    data-el="form-row"
    :class="{ 'lg:flex-row lg:items-center': !vertical }"
  >
    <label
      class="m-0"
      v-if="label"
      :class="{
        'w-full': vertical,
        'lg:w-42 w-full md:w-36': !vertical && !fluid,
        'w-auto': fluid,
      }"
    >
      <FormLabel
        :label="label"
        :required="required"
        :notes="notesExpanded ? undefined : notes"
        notes-position="right"
        :size="size"
      >
        <template v-if="$slots && $slots.notes"><slot name="notes" /></template>
      </FormLabel>
    </label>
    <section class="flex w-full flex-1 flex-col gap-1" data-id="fg-slot-value">
      <!-- content -->
      <span v-if="value">{{ value }}</span>
      <slot v-else />
      <!-- notes expanded -->
      <div class="text-xs text-gray-500" v-if="hasNotes && notesExpanded">
        <span v-if="$slots && $slots.notes"><slot name="notes" /></span>
        <span v-else>{{ notes }}</span>
      </div>
    </section>
  </div>
</template>
<script lang="ts" setup>
import { computed, useSlots } from 'vue';
import FormLabel from '../../components/form/FormLabel.vue';
import type { FormSize } from '../../lib/services/types';

const props = withDefaults(
  defineProps<{
    value?: string | number | null;
    fluid?: boolean;
    notesExpanded?: boolean;
    label?: string;
    notes?: string;
    required?: boolean;
    vertical?: boolean;
    size?: FormSize;
  }>(),
  {
    size: 'md',
    fluid: false,
    value: undefined,
    notesExpanded: false,
    label: '',
    notes: '',
    required: false,
    vertical: false,
  },
);
const slots = useSlots();
const hasNotes = computed(() => props.notes || slots.notes);
</script>
